import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? 'https://api.suppova.com/api'
    : (process.env.REACT_APP_API_URL || 'http://localhost:9292/api'),
  withCredentials: true,
});

// Attach stored auth token to every request
axiosInstance.interceptors.request.use(config => {
  const token = localStorage.getItem('auth_token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

export const setAuthToken = token => {
  if (token) localStorage.setItem('auth_token', token);
  else localStorage.removeItem('auth_token');
};

export default axiosInstance;
